<template>
    <section class="text-and-text">
        <div class="container" data-aos="fade-up">
            <h2>{{ commonTitle }}</h2>
            <p class="subtitle">
                <slot />
            </p>
            <!-- Luxury Products -->
            <div class="luxury-products">
                <div v-for="(luxuryProduct, index) in luxuryProducts" :key="index" class="luxury-product"
                    data-aos="fade-up">
                    <h4>{{ luxuryProduct.name }}</h4>
                    <p>{{ luxuryProduct.description }}</p>
                    <span class="luxury-price">{{ luxuryProduct.price }}</span>
                </div>
            </div>

            <div class="row">
                <div class="col-md-6" data-aos="fade-right">
                    <div data-aos="fade-up">
                        <h5 class="column-title">{{ title1 }}</h5>
                        <ul class="service-list">
                            <li v-for="(service, index) in services1" :key="index">
                                <div class="service-item">
                                    <div class="service-text">
                                        <p class="service-name">{{ service.name }}</p>
                                        <p class="service-description">{{ service.description }}</p>
                                    </div>
                                    <span class="service-price">{{ service.price }}</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-md-6">
                    <div data-aos="fade-up">
                        <h5 class="column-title">{{ title2 }}</h5>
                        <ul class="service-list">
                            <li v-for="(service, index) in services2" :key="index">
                                <div class="service-item">
                                    <div class="service-text">
                                        <p class="service-name">{{ service.name }}</p>
                                        <p class="service-description">{{ service.description }}</p>
                                    </div>
                                    <span class="service-price">{{ service.price }}</span>
                                </div>
                            </li>
                        </ul>


                    </div>
                </div>
                <!-- "Prenota Ora" (Book Now) Button -->
                <button class="book-now-button" @click="handleBookNowClick" data-aos="fade-left">Prenota Ora</button>
            </div>
        </div>
    </section>
</template>
  
<script>
export default {
    props: {
        commonTitle: {
            type: String,
            required: true,
        },
        title1: {
            type: String,
            required: true,
        },
        title2: {
            type: String,
            required: true,
        },
        services1: {
            type: Array,
            default: () => [],
        },
        services2: {
            type: Array,
            default: () => [],
        },
        luxuryProducts: {
            type: Array,
            default: () => [],
        },
    },
    methods: {
        handleBookNowClick () {
            // Redirect to the specified link
            window.open("https://linktr.ee/giorgio_parrucchieri", "_blank");
        }
    }
};
</script>
  
<style scoped>
h2 {
    font-weight: 500;
    font-size: 28px;
    color: #21413c;
    text-align: center;
    margin-bottom: 20px;
}

h4 {
    font-weight: 500;
    /* Adjusted for consistency */
    font-size: 24px;
    /* Slightly reduced font size */
    color: #21413c;
    text-align: center;
    margin-bottom: 15px;
    /* Reduced margin */
}

.book-now-button {
    display: block;
    margin: 20px auto;
    padding: 10px 20px;
    background-color: #21413c;
    color: #fff;
    border: none;
    cursor: pointer;
}

.subtitle {
    text-align: center;
    margin-bottom: 5%;
}

.column-title {
    padding-bottom: 5%;
    font-weight: 500;
    font-size: 20px;
    /* Reduced font size */
    color: #21413c;
}

.luxury-products {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    margin-bottom: 20px;
}

.luxury-product {
    width: 100%;
    max-width: 300px;
    text-align: center;
    margin-bottom: 20px;
    border: 1px solid #21413c;
    padding: 2%;
}

.service-list {
    list-style: none;
    padding: 0;
}

.service-list li {
    border-bottom: 1px solid #d3d3d3;
    /* Add a subtle separation line between services */
    margin-bottom: 10px;
    /* Adjusted margin for more spacing between services */
}

.service-item {
    display: flex;
    justify-content: space-between;
}

.service-text {
    flex-grow: 1;
}

.service-name {
    font-weight: 500;
    margin-bottom: 0;
    /* Maintain a slight margin between name and description */
}

.service-description {
    color: #848484;
}

.service-price {
    text-align: center;
    /* font-weight: bold;*/
    margin-top: auto;
    margin-bottom: 10px;
    color: #848484;
    margin: auto;
}

.luxury-price {
    /* font-weight: bold;
    color: #21413c;*/
    font-size: 18px;
    color: #848484;
}
</style>
